import * as api from "~/api";
import { USER } from "~/utils/urlApi";
import { getBaseUrl } from "~/utils/getBaseUrl";

export const apiGetUserInfoByFBCode = code => {
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  };
  const data = new FormData();
  data.append("code", code);
  return api.postHttpRequestAsync(USER.LOGIN_SMS_FB, data, config);
};

export const loginByFirebase = idToken => {
  const postData = {
    token: idToken
  };
  return api.postHttpRequestAsync(
    `${getBaseUrl()}/user/firebase-login`,
    postData
  );
};

export const loginByZalo = code => {
  const postData = {
    code: code
  };
  return api.postHttpRequestAsync(`${getBaseUrl()}/user/zalo-login`, postData);
};
